import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPromptsPageEdit from "../../../views/admin/prompts";
import AdminPromptsPageAdd from "../../../views/admin/prompts/add";

const AdminPromptsPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminPromptsPageAdd />
      <AdminFooter />
    </div>
  );
};

export default AdminPromptsPage;
